<template>
  <div v-clickOutside="close" class="border-2 rounded-full w-165" :class="isDarkMode ? 'border-hover' : 'border-dark-600 hover:bg-grey-150'">
    <div class="relative">
      <div class="px-12 py-4 flex justify-between items-center cursor-pointer" @click="toggle">
        <span class="text-15 truncate text-center font-semibold w-full">{{ names }}</span>
        <i class="icon-keyboard-arrow-down text-14" :class="{ 'expanded': visible }" />
      </div>

      <div
        class="absolute top-40 left-0 z-50 shadow rounded-4 max-h-300 overflow-y-auto w-full"
        :class="[{ hidden : !visible, visible }, isDarkMode ? 'bg-sidebar' : 'bg-primary']"
      >
        <CheckboxModule
          :model-value="isCheckedAll"
          class="border-b p-12 cursor-pointer hover:bg-selection leading-normal text-15 font-bold"
          :class="isDarkMode ? 'border-hover' : 'border-grey-500'"
          label="All spaces"
          @update:modelValue="selectAll"
        />
        <CheckboxModule
          v-for="item in options"
          :key="item.id"
          :model-value="isChecked(item)"
          class="px-10 py-7 cursor-pointer hover:bg-selection leading-normal text-15"
          :label="item.title"
          :disabled-deselect="selectedBooks.length === 1"
          @update:modelValue="selectItem(item)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { useStore } from 'vuex'
import { defineComponent, ref, computed } from 'vue'
import CheckboxModule from '@/components/shared/form-controls/CheckboxModule'
import { useRoute } from 'vue-router'

export default defineComponent({
  components: { CheckboxModule },
  props: {
    selectedBooks: Array,
    options: { type: Array }
  },

  emits: ['onSelect'],

  setup (props, { emit }) {
    const store = useStore()
    const route = useRoute()

    const visible = ref(false)

    const isDarkMode = computed(() => store.getters.isDarkMode)

    const isCheckedAll = computed(() => props.selectedBooks.length === props.options.length)

    const isChecked = computed(() => option => props.selectedBooks.some(item => item.id === option.id))

    const names = computed(() => {
      const item = props.selectedBooks.map(b => b.title)

      return item.join(', ')
    })

    const toggle = () => {
      if (!props.disabled) visible.value = !visible.value
    }

    const close = () => {
      visible.value = false
    }

    const selectItem = (option) => {
      let selectedItems = props.selectedBooks

      if (selectedItems.some(item => item.id === option.id)) {
        if (selectedItems.length === 1) return
        selectedItems = selectedItems.filter(i => i.id !== option.id)
      } else {
        selectedItems.push(option)
      }

      emit('onSelect', selectedItems)
    }

    function selectAll () {
      let selectedItems = props.selectedBooks

      if (isCheckedAll.value) {
        selectedItems = [props.options.find(opt => opt.id === parseInt(route.query.spaces))]
      } else {
        selectedItems = props.options
      }

      emit('onSelect', selectedItems)
    }

    return {
      names,
      visible,
      isChecked,
      isDarkMode,
      isCheckedAll,
      // function
      close,
      toggle,
      selectItem,
      selectAll
    }
  }
})
</script>

<style lang="scss" scoped>
.expanded {
  transform: rotateZ(180deg) translateY(2px);
}
</style>
